import type { GenericCardView } from '../../kanban/components/genericCards';
import { toDurationMs } from '../trackingUtils';
import useMtText from './useMtText';

const KanbanStepCard = ({ card }: { card: GenericCardView }) => {
    const { msg, formatDuration, formatDateTime } = useMtText();
    const estimateMs = toDurationMs(card.estimatedTime);
    const repairMs = toDurationMs(card.estimatedRepairTime);
    const tone = `mt-ksc--${card.status}${card.late ? ' mt-ksc--late' : ''}`;

    return (
        <div className={`mt-ksc ${tone}`}>
            <button
                type='button'
                className='mt-ksc__open'
                data-clickable={card.status !== 'todo'}
                onClick={card.openForm}
            >
                <span className='mt-kr'>
                    <span>{msg('intl-msg:occurrence.step.start')}</span>
                    <span className='mt-num'>{card.startDate ? formatDateTime(card.startDate) : '-'}</span>
                </span>
                <span className='mt-kr'>
                    <span>{msg('intl-msg:occurrence.step.completion')}</span>
                    <span className='mt-num'>{card.endDate ? formatDateTime(card.endDate) : '-'}</span>
                </span>
                <span className='mt-kr'>
                    <span>{msg('intl-msg:occurrence.card.estimatedTime')}</span>
                    <span className='mt-num'>
                        <span className='rioglyph rioglyph-time-alt' />
                        {estimateMs !== undefined ? formatDuration(estimateMs) : '-'}
                    </span>
                </span>
                {repairMs !== undefined && (
                    <span className='mt-kr'>
                        <span>{msg('intl-msg:kanban.genericCards.estimatedRepairTime')}</span>
                        <span className='mt-num'>
                            <span className='rioglyph rioglyph-time-alt' />
                            {formatDuration(repairMs)}
                        </span>
                    </span>
                )}
                <span className='mt-kr'>
                    <span>{msg('intl-msg:occurrence.card.elapsedTime')}</span>
                    <span className={`mt-num${card.elapsedMs ? ' mt-kr__strong' : ''}`}>
                        <span className='rioglyph rioglyph-time-alt' />
                        {card.elapsedMs ? formatDuration(card.elapsedMs) : '-'}
                    </span>
                </span>
                {card.typeLabel && (
                    <span className='mt-kr'>
                        <span>{msg('intl-msg:occurrence.card.type')}</span>
                        <span>{card.typeLabel}</span>
                    </span>
                )}
                <span className='mt-ksc__grow'>
                    {card.late && (
                        <span
                            className='rioglyph rioglyph-warning-sign mt-ksc__warn'
                            title={msg('intl-msg:occurrence.card.timeExceeded')}
                        />
                    )}
                </span>
            </button>

            {card.passageCount > 1 && (
                <button
                    type='button'
                    className='mt-ksc__passage'
                    title={msg('intl-msg:kanban.genericCards.viewPassageHistory')}
                    onClick={card.openHistory}
                >
                    <span className='rioglyph rioglyph-refresh' />
                    {msg('intl-msg:kanban.genericCards.passage', { count: card.passageCount })}
                </button>
            )}

            <button
                type='button'
                className={`mt-ksc__pill${card.canChangeStatus && !card.statusDisabled ? ' mt-ksc__pill--action' : ''}`}
                disabled={card.statusDisabled}
                aria-busy={card.statusLoading}
                onMouseEnter={() => card.setStatusHovered(true)}
                onMouseLeave={() => card.setStatusHovered(false)}
                onClick={card.requestStatusChange}
            >
                {card.statusText}
            </button>
        </div>
    );
};

export default KanbanStepCard;
